import { DaftarPeriode } from 'app/KinerjaAsnSwastaPage/pages/pejabat-penilai-kinerja/periodik/DaftarPeriode'
import PageGuardDinas from 'app/KinerjaDinasPage/components/PageGuardDinas'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { GetServerSidePropsResult, NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ): Promise<GetServerSidePropsResult<{}>> => {
    const isKinerjaAsnSwastaEnabled =
      toggle?.['kinerja-asn-swasta-enabled'] || false
    const isKinerjaAsnSwastaPeriodikEnabled =
      toggle?.['kinerja-asn-swasta-periodik-enabled'] || false

    if (!isKinerjaAsnSwastaEnabled || !isKinerjaAsnSwastaPeriodikEnabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return {
      props: {},
    }
  },
})

export default function Page() {
  return (
    <PageGuardDinas>
      <DaftarPeriode />
    </PageGuardDinas>
  )
}

Page.Layout = KinerjaLayout

Page.layoutOpts = {
  hasHeader: true,
  className: '!max-w-full min-h-screen',
  forceResolution: true,
}
